import { render } from "./alert.vue?vue&type=template&id=906424ac&scoped=true"
const script = {}

import "./alert.vue?vue&type=style&index=0&id=906424ac&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-906424ac"]])

export default __exports__